export const receiptStatus = {
  DRAFT: "draft",
  PUBLISH: "publish",
};

export default [
  { key: receiptStatus.DRAFT, label: "บันทึกร่าง" },
  { key: receiptStatus.PUBLISH, label: "เรียบร้อย" },
];
